import axios from "axios";
import { ICardElementWithChildren } from "backend/model/model";
import { useQuery } from "react-query";

const useScorecardElements = (topElementId: string, period: string) => {
  return useQuery<ICardElementWithChildren[]>(
    `use-scorecardElements-${topElementId}-${period}`,
    async () => {
      if (!topElementId || !period) return [];

      const response = await axios.post("meaquery", {
        query: `[${topElementId}].childobjects(recursive=1,criteria="(typename=\\\"KPI\\\" OR typename=\\\"Initiative\\\") AND hasreferencescorecard=\\\"0\\\"")`,
        attributes: `name,typename,symbol,periodlevelid,periodlevelname,parentobjects(as="parent_element_id"),scorecardid,prettyvalue(series="ACT",period="${period}", as="ACT"),value(series="JS_ATTR",period="latestforseries",as="JS_ATTR")`,
        sortby: "name",
      });

      return response.data?.data || ([] as ICardElementWithChildren[]);
    },
    {
      enabled: true,
      staleTime: 10 * 60 * 1000, // cache for ten minutes
      cacheTime: 10 * 60 * 1000,
    }
  );
};

export default useScorecardElements;
